import { getEditUrl, openInNewTab } from 'tools/tools';
import React from 'react';
import { TileInfo } from 'app/home/index.functions';
import { UserAuth } from 'store/auth';
import { useNavigate } from 'react-router-dom';
import IconMi from 'components/common/icon/IconMi';
import { alpha, Box } from '@mui/material';
import { useHomeContext } from 'app/home/context';

export const TileEdit = function ({
    style,
    defaultStyle,
    src,
    tile,
    tileicons,
    userauth,
}: {
    style?: any;
    defaultStyle?: any;
    src?: string;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
    userauth: UserAuth;
}) {
    const ctx = useHomeContext();
    const [isEmbedded, newTab, navigationBack] = [ctx.isEmbedded, ctx.newTab, ctx.navigationBack];

    if (!('Y' == tile.is_tech_editor || userauth.userInfo?.isAdmin) || !navigationBack) return null;

    if (undefined === defaultStyle)
        defaultStyle = {
            position: 'absolute',
            top: '4px',
            right: '30px',
        };

    const navigate = useNavigate();
    const editElement = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        let url = getEditUrl(tile.element_type || '') + tile.element_id;
        if (newTab || e.ctrlKey) openInNewTab(url);
        else navigate(url);
        return false;
    };

    return (
        <Box
            className={'tile-element__edit'}
            onClick={(e) => editElement(e)}
            style={{ ...style, ...defaultStyle }}
            sx={{ display: 'flex', color: (theme) => alpha(theme.palette.text.primary, 0.64) }}
        >
            <IconMi icon={'gear'} fontSize={'15'} />
        </Box>
    );
};
